import React, { useState, useEffect } from 'react';
import { FaGithub } from "react-icons/fa";
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Logo from '../assets/logo.png';

export default function Navbar() {
  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.7 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleScroll = (e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate(`/#${id}`);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleTryDemo = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/#hero', { state: { toggleDemo: true } });
    } else {
      const heroSection = document.getElementById('hero');
      if (heroSection) {
        heroSection.scrollIntoView({ behavior: 'smooth' });
        const event = new CustomEvent('toggleDemo');
        window.dispatchEvent(event);
      }
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-30 mx-auto w-full max-w-screen-md bg-gradient-to-br from-violet-50 to-indigo-100 py-3 shadow-lg backdrop-blur-md md:top-6 md:rounded-3xl lg:max-w-screen-lg">
      <div className="px-4">
        <div className="flex items-center justify-between">
          <div className="flex shrink-0 text-black">
            <Link aria-current="page" className="flex items-center" to="/">
              <img src={Logo} alt="Logo" className='w-20' />
            </Link>
          </div>
          <div className="flex items-center justify-end gap-3">
            <a
              className="hidden items-center justify-center rounded-xl bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all duration-150 hover:bg-gray-50 sm:inline-flex"
              href="https://github.com/mahsook3/Cross-Border-backend"
              target='_blank'
            >
              <FaGithub />&nbsp;Github
            </a>
            <button
              className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-150 hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={handleTryDemo}
            >
              Try Demo
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}